import { toast } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export type SendAudioProduct = 'scan' | 'remote-guarding' | 'enterprise';

export interface CameraAudioTarget {
  alarmId?: string;
  locAlarmId?: string;
  escalationId?: string;
  product?: SendAudioProduct;
}

export function buildCameraAudioUrl(
  cameraId: string | null,
  target: CameraAudioTarget = {}
) {
  const {
    alarmId,
    locAlarmId,
    escalationId,
    product = 'remote-guarding',
  } = target;
  const params = new URLSearchParams();
  if (alarmId) {
    params.append('alarmId', alarmId);
  }
  if (product === 'scan') {
    if (locAlarmId) {
      params.append('alarmGroupId', locAlarmId);
    }
    params.append('product', 'scan');
    if (escalationId) {
      params.append('escalationId', escalationId);
    }
  } else {
    if (locAlarmId) {
      params.append('locationAlarmId', locAlarmId);
    }
    params.append('product', 'remote-guarding');
  }

  return `/v2/orm/camera/audio/${cameraId}?${params.toString()}`;
}

export function useSendAudio(
  cameraId: string | null,
  alarmId?: string,
  locAlarmId?: string,
  onSuccess?: () => void,
  escalationId?: string,
  product: SendAudioProduct = 'remote-guarding'
) {
  const url = buildCameraAudioUrl(cameraId, {
    alarmId,
    locAlarmId,
    escalationId,
    product,
  });

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<null, FormData>(request, {
    onSuccess,
    onError: () => {
      toast(
        'Talkdown failed — audio was not sent to the camera. Please retry.',
        {
          type: 'error',
        }
      );
    },
    getBody: (data) => data,
    onSuccessInvalidationKeys: [
      ['alarm_updates', alarmId ?? '', locAlarmId ?? ''],
      ['location_alarm_updates'],
    ],
  });
}

export default useSendAudio;
